import React, { useEffect, useState, useContext } from 'react';
import { Box, Stack, Tabs, Tab, Typography, Container } from '@mui/material';
import PropTypes from 'prop-types';
import AcceptedShipment from './AcceptedShipment';
import SearchContainerPanel from './SearchContainerPanel';
import { dashboardStatusCount } from '../../api/dashboard';
import { StoreContext } from '../../components/Store';
import { is360PayStaff, isEORIUser } from '../../utils/roles';
import { READ_ONLY_LABEL } from '../../utils/constants';

function TabPanel(props) {
  const { children, value, index } = props;

  return (
    <div role="tabpanel" hidden={value !== index} id={`vertical-tabpanel-${index}`} className="wrapper-tabspanel">
      {value === index && (
        <Box>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}

export default function Dashboard() {
  const [value, setValue] = useState(0);
  const store = useContext(StoreContext);
  const [shipmentStatus, setShipmentStatus] = useState([]);
  const [countForApi, setCountForApi] = useState(0);
  const [showPages, setShowPages] = useState(false);
  const [aPICall, setAPICall] = useState(false);
  const [currentCompanyName, setCurrentCompanyName] = useState('');
  const [callAPIcallTimeout, setCallAPIcallTimeout] = useState('');
  const [paginationResetKey, setPaginationResetKey] = useState(0);

  const todayShipmentTabStyles = {
    '&.Mui-disabled': {
      color: '#000',
      fontSize: '16px',
      textDecoration: 'none !important', //used !important here, otherwise the underline would still be there
    },
  };

  const apiCallForShipmentStatus = (fromTimeout) => {
    if (fromTimeout) {
      setCallAPIcallTimeout(true);
    }
    dashboardStatusCount().then((data) => {
      store.shipmentStatus[1](data.data);
      setShipmentStatus(data.data);
    });
  };

  useEffect(() => {
    setCurrentCompanyName(getCompanyName());
  }, []);

  const handleCompanyNameChange = (newCompanyName) => {
    setCurrentCompanyName(newCompanyName);
  };

  const handlefilterApiCall = () => {
    setCountForApi(countForApi + 1);
  };

  const isResponseCame = () => {
    setShowPages(true);
  };
  const companySetEori = () => {
    setAPICall(true);
  };

  const getCompanyName = () => {
    //get the companyId from the session storage
    const companyId = sessionStorage.getItem('companyid');
    const companyName =
      store.companyList[0].length > 0
        ? store?.companyList?.[0]?.filter?.((e) => e.companyId == companyId)?.[0]?.companyName
        : '';
    return companyName;
  };

  useEffect(() => {
    async function fetchData() {
      try {
        apiCallForShipmentStatus();
      } catch (err) {
        console.log(err);
      }
    }
    fetchData();
  }, []);

  const displayCompanyName = !currentCompanyName || currentCompanyName === 'ALL' ? 'EORI UK' : currentCompanyName;

  const hasShipmentErrors = shipmentStatus.some((tab) => tab.status.toUpperCase() === 'ERRORS' && tab.statusCount > 0);

  return (
    <Container
      maxWidth="xl"
      sx={{
        mb: 6,
      }}
    >
      <div className="stepper-wrapper-tabs-dashboard">
        <Stack direction="row" gap={2} className="stepper-wrapper-tabs">
          <div className="rowWrapper col-container" style={{ justifyContent: 'flex-start', flexDirection: 'column' }}>
            <div className="dashboard-heading">GB ENS</div>
            {showPages && !isEORIUser() && (
              <Tabs
                className={hasShipmentErrors ? 'wrapper-tabs error' : 'wrapper-tabs no-error'}
                orientation="vertical"
                value={value}
                onChange={(_event, newValue) => setValue(newValue)}
                sx={{
                  '& .MuiTabs-indicator': {
                    display: 'none',
                  },
                }}
              >
                <div
                  className={`shiipment-information-dashboard shiipment-information ${hasShipmentErrors ? 'error-text' : ''}`}
                >
                  {hasShipmentErrors ? 'Action Required' : 'Shipments Overview'}
                </div>

                {shipmentStatus
                  .filter((tab) => {
                    if (hasShipmentErrors) {
                      return tab.status.toUpperCase() === 'ERRORS';
                    } else {
                      return true;
                    }
                  })
                  .map((tab, index) => {
                    return (
                      <Tab
                        className="no-error"
                        key={index}
                        label={tab.statusCount + '  ' + tab.status}
                        {...a11yProps(index)}
                        disabled
                        sx={todayShipmentTabStyles}
                      />
                    );
                  })}

                {!shipmentStatus.length && <Tab label="No shipments found" disabled />}
              </Tabs>
            )}
            <SearchContainerPanel
              onResetPagination={() => setPaginationResetKey((prev) => prev + 1)}
              handlefilterApiCall={handlefilterApiCall}
              companySetEori={companySetEori}
              handleCompanyNameChange={handleCompanyNameChange}
            />
          </div>

          <div className="rowWrapper" style={{ justifyContent: 'flex-start', flexDirection: 'column' }}>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
              <div className="dashboard-heading">
                Shipping Status {isEORIUser() && displayCompanyName ? ' - ' + displayCompanyName : ''}
                {is360PayStaff() && READ_ONLY_LABEL}
              </div>
              <div className="dashboard-heading">Results : {store.shipmentTotalCount[0]}</div>
            </div>

            <div className="dashboard-main" style={{ width: '100%', display: 'flex', flexDirection: 'row' }}>
              <TabPanel index={0} value={value}>
                <AcceptedShipment
                  paginationResetKey={paginationResetKey}
                  callAPIcallTimeout={callAPIcallTimeout}
                  countForApi={countForApi}
                  isResponseCame={isResponseCame}
                  aPICall={aPICall}
                  shipmentStatusAPICall={apiCallForShipmentStatus}
                />
              </TabPanel>
            </div>
          </div>
        </Stack>
      </div>
    </Container>
  );
}

TabPanel.propTypes = {
  children: PropTypes.func,
  value: PropTypes.string,
  index: PropTypes.string,
};
